/**
 * Pups&Yoga Premium V2 — Theme JavaScript
 * Handles: Navigation, Accordions, Carousels, Video, Lazy Loading, Scroll Animations, Variants
 */

(function () {
  'use strict';

  /* ---------- Sticky Header Scroll Effect ---------- */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ---------- Mobile Menu Toggle ---------- */
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav = document.querySelector('.header__nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  /* ---------- FAQ Accordion ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const content = item.querySelector('.accordion__content');
      const inner = content.querySelector('.accordion__content-inner');
      const isOpen = item.classList.contains('is-open');

      // Close all siblings
      const parent = item.closest('.faq-accordion');
      if (parent) {
        parent.querySelectorAll('.accordion__item.is-open').forEach(openItem => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.accordion__content').style.maxHeight = '0';
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        content.style.maxHeight = '0';
      } else {
        item.classList.add('is-open');
        content.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Video Section ---------- */
  document.querySelectorAll('.video-section__poster').forEach(poster => {
    poster.addEventListener('click', () => {
      const wrapper = poster.closest('.video-section__wrapper');
      const videoUrl = wrapper.dataset.videoUrl;
      const videoType = wrapper.dataset.videoType;

      poster.style.display = 'none';

      if (videoType === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.src = videoUrl + '?autoplay=1&rel=0';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        wrapper.appendChild(iframe);
      } else if (videoType === 'vimeo') {
        const iframe = document.createElement('iframe');
        iframe.src = videoUrl + '?autoplay=1';
        iframe.allow = 'autoplay; fullscreen';
        iframe.allowFullscreen = true;
        wrapper.appendChild(iframe);
      } else if (videoType === 'mp4') {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.autoplay = true;
        video.controls = true;
        video.playsInline = true;
        wrapper.appendChild(video);
      }
    });
  });

  /* ---------- Lazy Load Images ---------- */
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          img.classList.add('loaded');
          imageObserver.unobserve(img);
        }
      });
    }, { rootMargin: '100px' });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  /* ---------- Scroll Animations ---------- */
  if ('IntersectionObserver' in window) {
    const animElements = document.querySelectorAll('.fade-in-up, .stagger-children');
    const animObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animElements.forEach(el => animObserver.observe(el));
  }

  /* ---------- Variant Selector (Product Page) ---------- */
  function initVariantSelector() {
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    const hiddenSelect = productForm.querySelector('select[name="id"]');
    if (!hiddenSelect) return;

    // Build a map of "Option1 / Option2 / ..." => variant option element
    const allOptions = hiddenSelect.querySelectorAll('option');
    const variantMap = {};
    allOptions.forEach(opt => {
      // Shopify option text format: "Option1 - $price" or "Option1 / Option2 - $price"
      const titlePart = opt.textContent.split(' - ')[0].trim();
      variantMap[titlePart] = {
        id: opt.value,
        available: !opt.disabled
      };
    });

    // Get all option groups
    const optionGroups = document.querySelectorAll('.product-info__variants');
    const selectedOptions = {};

    // Initialize selected options from current state
    optionGroups.forEach(group => {
      const selected = group.querySelector('.variant-selector__option.is-selected');
      if (selected) {
        selectedOptions[selected.dataset.optionPosition] = selected.dataset.value;
      }
    });

    // Handle option button clicks
    document.querySelectorAll('.variant-selector__option').forEach(option => {
      option.addEventListener('click', () => {
        const position = option.dataset.optionPosition;
        const value = option.dataset.value;

        // Update visual state within the same group
        const siblings = option.parentElement.querySelectorAll('.variant-selector__option');
        siblings.forEach(s => s.classList.remove('is-selected'));
        option.classList.add('is-selected');

        // Track current selection
        selectedOptions[position] = value;

        // Build the variant title string to match
        const orderedValues = Object.keys(selectedOptions)
          .sort()
          .map(k => selectedOptions[k]);
        const variantTitle = orderedValues.join(' / ');

        // Find matching variant
        const match = variantMap[variantTitle];
        if (match) {
          hiddenSelect.value = match.id;

          // Update Add to Cart button state
          const addToCartBtn = productForm.querySelector('.product-info__add-to-cart');
          if (addToCartBtn) {
            if (match.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = addToCartBtn.dataset.addText || 'Book Now';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Sold Out';
            }
          }

          // Update price if variant prices differ
          const priceEl = document.querySelector('.product-info__price');
          if (priceEl) {
            const selectedOpt = hiddenSelect.querySelector('option[value="' + match.id + '"]');
            if (selectedOpt) {
              const priceText = selectedOpt.textContent.split(' - ')[1];
              if (priceText) {
                priceEl.textContent = priceText.trim();
              }
            }
          }
        } else {
          // No matching variant — check single option (default variant)
          const singleMatch = variantMap[value];
          if (singleMatch) {
            hiddenSelect.value = singleMatch.id;
          }
        }
      });
    });
  }

  initVariantSelector();

  /* ---------- Product Gallery Lightbox ---------- */
  document.querySelectorAll('.product-gallery__item img').forEach(img => {
    img.addEventListener('click', () => {
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.9);display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:2rem;';
      const bigImg = document.createElement('img');
      bigImg.src = img.src.replace(/&width=\d+/, '&width=1200');
      bigImg.style.cssText = 'max-width:100%;max-height:90vh;object-fit:contain;border-radius:0.5rem;';
      overlay.appendChild(bigImg);
      overlay.addEventListener('click', () => overlay.remove());
      document.addEventListener('keydown', function handler(e) {
        if (e.key === 'Escape') {
          overlay.remove();
          document.removeEventListener('keydown', handler);
        }
      });
      document.body.appendChild(overlay);
    });
  });

  /* ---------- AJAX Add to Cart ---------- */
  function initAjaxCart() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (!btn || btn.disabled) return;
        const originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(item => {
          btn.textContent = 'Added!';
          btn.classList.add('btn--success');
          updateCartCount();
          showCartToast(item.product_title);
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            btn.classList.remove('btn--success');
          }, 2500);
        })
        .catch(() => {
          btn.textContent = 'Error — Try Again';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.header__cart-count').forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }

  function showCartToast(productTitle) {
    const toast = document.getElementById('cart-toast');
    if (!toast) return;
    const msg = toast.querySelector('.toast__message');
    if (msg) msg.textContent = productTitle ? 'Added to cart: ' + productTitle : 'Added to cart!';
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  initAjaxCart();

})();

/* ============================================================
   PY v2 — Global reveal-on-scroll (for .py-reveal / .py-reveal-stagger)
   ============================================================ */
(function() {
  function init() {
    var els = document.querySelectorAll('.py-reveal, .py-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) {
      // Already intersecting at load? Reveal immediately.
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('in');
      } else {
        io.observe(el);
      }
    });
  }
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  // Re-run when theme editor adds/replaces sections
  document.addEventListener('shopify:section:load', init);
})();
